<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="workCenter.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="workCenter"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item v-if="workCenter.pkId" label="工作中心编号">
        <el-input v-model="workCenter.workCenterNo" disabled/>
      </el-form-item>
      <el-form-item label="工作中心名称" prop="workCenterName">
        <el-input v-model="workCenter.workCenterName" placeholder="请输入工作中心名称"/>
      </el-form-item>
      <el-form-item label="生产类型" prop="productionType">
        <el-select v-model="workCenter.productionType" clearable placeholder="请选择生产类型">
          <el-option v-for="(item, index) in productionTypeList" :key="index" :label="item.name" :value="item.code"/>
        </el-select>
      </el-form-item>
      <el-form-item label="载具绑定类型" prop="bindVehicleType">
        <el-select v-model="workCenter.bindVehicleType" clearable placeholder="请选择载具绑定类型">
          <el-option v-for="(item, index) in bindVehicleTypeList" :key="index" :label="item.name" :value="item.code"/>
        </el-select>
      </el-form-item>
      <el-form-item label="上料验证" prop="isLoadMaterial">
        <el-select v-model="workCenter.isLoadMaterial" placeholder="请选择是否上料验证">
          <el-option label="不需要" :value="0"/>
          <el-option label="需要" :value="1"/>
        </el-select>
      </el-form-item>
      <el-form-item label="所属车间" prop="workshopName">
        <el-input v-model="workCenter.workshopName" placeholder="请选择车间" readonly>
          <el-button slot="append" @click="$refs.selectWorkShop.open()">选择</el-button>
        </el-input>
        <work-shop-select ref="selectWorkShop" @select="selectWorkShop"/>
      </el-form-item>
      <el-form-item label="线边库" prop="locationName">
        <el-input v-model="workCenter.locationName" placeholder="请选择边线库">
          <el-button slot="append" @click="$refs.warehouseSelect.open()"> 选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="工作中心工时" prop="fixedWorkTime">
        <el-input v-model="workCenter.fixedWorkTime" placeholder="请输入工作中心工时"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确实</el-button>
    </span>
    <warehouse-select ref="warehouseSelect" @select="kwSelect"/>
  </el-dialog>
</template>

<script>
  import WorkShopSelect from "@/views/information/WorkShop/WorkShopSelect";
  import WarehouseSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";

  export default {
    name: "WorkCenterEdit",
    components: {WorkShopSelect, WarehouseSelect},
    props: {
      productionTypeList: {
        type: Array,
        required: true,
      },
      bindVehicleTypeList: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        workCenter: {
          pkId: 0,
          workCenterNo: "",
          workCenterName: "",
          workshopName: "",
          workshopId: "",
          productionType: "",
          bindVehicleType: "",
          isLoadMaterial: 0,
          locationName: "",
          locationId: "",
          fixedWorkTime: 0,
        },
        ruleValidate: {
          workCenterName: {required: true, message: "请输入工作中心名称", trigger: "blur"},
          productionType: {required: true, message: "请选择生产类型", trigger: "change"},
          bindVehicleType: {required: true, message: "请选择载具绑定类型", trigger: "change"},
          workshopName: {required: true, message: "请选择所属车间", trigger: "change"},
          locationName: {required: false, message: "请选择线边库", trigger: "change"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.workCenter.pkId = row.pkId;
          this.getData();
        }
      },

      // 根据工作中心Id查看详情
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `workCenters/${this.workCenter.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.workCenter = Object.assign(this.workCenter, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择车间
      selectWorkShop(row) {
        this.workCenter.workshopId = row.pkid;
        this.workCenter.workshopName = row.workshopName;
      },

      // 选择边线库
      kwSelect(row) {
        console.log(row);
        this.workCenter.locationId = row.pkId;
        this.workCenter.locationName = row.warehouseAreaName;
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "workCenters", this.workCenter)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.workCenter.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
